import React from 'react/addons';
import cx from 'classnames';


var ClassNameMixin = {
  propTypes: {
    className: React.PropTypes.string
  },

  getClassSet: function(classes) {
    classes = classes || {};

    if (this.props.className) {
      classes[this.props.className] = true;
    }
    return cx(classes);
  }
};

export default ClassNameMixin;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/ClassNameMixin.js
 **/